export enum EligibilityEmployerChoiceId {
  airLife = "d5LScrPCWIn5",
  albar = "1fc4hYxx53KH",
  amazon = "ALXY6RYKBVTr",
  americanCollegeOfRheumatology = "OO0vMMAJzWLt",
  apple = "AjiuetUcuy5D",
  countyOfDoor = "54wElWwh6SQs",
  demo = "TvMRqMrvfkMi",
  dexterRXISchoolDistrict = "aCYQiWFp54IV",
  effectiveSchool = "PtfGzLTRxA6c",
  eptam = "wPYZDAGHVnYs",
  exceptionalMotorcars = "wbcgBT1kCY5x",
  firstChoice = "1nJ65cyhh18G",
  fortBendCountyGovernment = "5GRgfu0B9f4J",
  fresenius = "3b1Bli2b6BZe",
  generalPlastics = "XXhxi0BA1XZO",
  horizonHealthPartners = "djD0aDXW3ISk",
  hydacTechnologyCorporation = "KAPqVRi51kMD",
  jimSchmidtChevrolet = "TDyAAMxBXc5v",
  jjSafety = "YWlwgEuAOeI7",
  johnsonAndJordanInc = "rYJFS43iWn5c",
  jpns = "qLo0sGkxDUBT",
  kineticGroup = "KS7beV6g2Ll7",
  knipper = "uZJi37MuHVp6",
  kwestGroup = "g7zSaWeQqDFv",
  kwikTrip = "oZlpyMeJMxwX",
  lilly = "vVjcv17F6WlJ",
  lochmuellerGroup = "sQav0cgzyXLh",
  managementMcoa = "MZOHxK2xDhXt",
  markCubanCompaniesMcchp = "NXWjVvLRh64U",
  matrixMedical = "plS9FZzLY2jT",
  bjs = "F8GN2UPKvArt",
  nimnicht = "KdoCwOdxKMsp",
  norAmColdStorage = "4fK82L5MDc8Z",
  northernPartnersCooperative = "ovG8A1ZTFviK",
  northfieldHospitalAndClinics = "GsDzrbqqF4Zs",
  permianRegionalHospital = "polqMy0A0OhF",
  prescryptive = "xBdIqSpWXKNF",
  revisionEnergy = "Yr9LKhj9TGWI",
  searsSeating = "5k2YF8z8T8m2",
  seveeAndMaherEngineers = "yOblIQrWH9PP",
  silverstoneLiving = "KtuJcQBWYDxx",
  sorensonCommunications = "ksfZ0BP67VOi",
  stateOfIndiana = "PxcU4opoCxXT",
  theBoelterCompanies = "xcPpJXMhJdgP",
  tkg = "eFiS5CSR8ZNW",
  unitedDerm = "o3YJ9iNpfdw9",
  unitedTrailers = "e8Y25dGSuvTw",
  weAreBlood = "2PclwiU3z3G2",
  wipfli = "hroIvEv66bHy",
  soleraPebtf = "s5o9le8r8a01",
  stateOfGeorgia = "Wv6vkFS2uyz2"
}

export enum EligibilityQuestionId {
  employer = "nnr4MisyYRqS",
  healthPlan = "Xr1URwgDrLB8"
}

export enum EligibilityHealthPlanChoiceId {
  anthemIndiana = "nvwPwhoPWjJv",
  evernorth = "EhJryoxsCGQQ",
  cignaIfp = "WSms00VLXTju",
  solera = "s1oDlEeVr9aQ",
  transcarent = "CAEVcKrBxBvN"
}

export const eligibilityEmployerChoiceValues = {
  [EligibilityEmployerChoiceId.airLife]: "AirLife",
  [EligibilityEmployerChoiceId.albar]: "Albar",
  [EligibilityEmployerChoiceId.amazon]: "Amazon",
  [EligibilityEmployerChoiceId.americanCollegeOfRheumatology]:
    "American College of Rheumatology",
  [EligibilityEmployerChoiceId.apple]: "Apple",
  [EligibilityEmployerChoiceId.countyOfDoor]: "County of Door",
  [EligibilityEmployerChoiceId.demo]: "Demo",
  [EligibilityEmployerChoiceId.bjs]: "BJ's",
  [EligibilityEmployerChoiceId.dexterRXISchoolDistrict]:
    "Dexter R-XI School District",
  [EligibilityEmployerChoiceId.effectiveSchool]: "Effective School",
  [EligibilityEmployerChoiceId.eptam]: "EPTAM",
  [EligibilityEmployerChoiceId.exceptionalMotorcars]: "Exceptional Motorcars",
  [EligibilityEmployerChoiceId.firstChoice]: "First Choice",
  [EligibilityEmployerChoiceId.fortBendCountyGovernment]:
    "Fort Bend County Government",
  [EligibilityEmployerChoiceId.fresenius]: "Fresenius",
  [EligibilityEmployerChoiceId.generalPlastics]: "General Plastics",
  [EligibilityEmployerChoiceId.horizonHealthPartners]:
    "Horizon Health Partners",
  [EligibilityEmployerChoiceId.hydacTechnologyCorporation]:
    "Hydac Technology Corporation",
  [EligibilityEmployerChoiceId.jimSchmidtChevrolet]: "Jim Schmidt Chevrolet",
  [EligibilityEmployerChoiceId.jjSafety]: "JJ Safety",
  [EligibilityEmployerChoiceId.johnsonAndJordanInc]: "Johnson & Jordan Inc",
  [EligibilityEmployerChoiceId.jpns]: "JPNS",
  [EligibilityEmployerChoiceId.kineticGroup]: "Kinetic Group",
  [EligibilityEmployerChoiceId.knipper]: "Knipper",
  [EligibilityEmployerChoiceId.kwestGroup]: "KWest Group",
  [EligibilityEmployerChoiceId.kwikTrip]: "Kwik Trip",
  [EligibilityEmployerChoiceId.lilly]: "Lilly",
  [EligibilityEmployerChoiceId.lochmuellerGroup]: "Lochmueller Group, Inc.",
  [EligibilityEmployerChoiceId.managementMcoa]: "Management MCOA",
  [EligibilityEmployerChoiceId.markCubanCompaniesMcchp]:
    "Mark Cuban Companies (MCHCP)",
  [EligibilityEmployerChoiceId.matrixMedical]: "Matrix Medical",
  [EligibilityEmployerChoiceId.nimnicht]: "Nimnicht",
  [EligibilityEmployerChoiceId.norAmColdStorage]: "Nor-Am Cold Storage",
  [EligibilityEmployerChoiceId.northernPartnersCooperative]:
    "Northern Partners Cooperative",
  [EligibilityEmployerChoiceId.northfieldHospitalAndClinics]:
    "Northfield Hospital and Clinics",
  [EligibilityEmployerChoiceId.permianRegionalHospital]:
    "Permian Regional Hospital (PRMC)",
  [EligibilityEmployerChoiceId.prescryptive]: "Prescryptive",
  [EligibilityEmployerChoiceId.revisionEnergy]: "Revision Energy",
  [EligibilityEmployerChoiceId.searsSeating]: "Sears Seating",
  [EligibilityEmployerChoiceId.seveeAndMaherEngineers]:
    "Sevee & Maher Engineers",
  [EligibilityEmployerChoiceId.silverstoneLiving]: "Silverstone Living",
  [EligibilityEmployerChoiceId.sorensonCommunications]:
    "Sorenson Communications, LLC",
  [EligibilityEmployerChoiceId.stateOfIndiana]: "State of Indiana",
  [EligibilityEmployerChoiceId.theBoelterCompanies]: "The Boelter Companies",
  [EligibilityEmployerChoiceId.tkg]: "TKG",
  [EligibilityEmployerChoiceId.unitedDerm]: "United Derm",
  [EligibilityEmployerChoiceId.unitedTrailers]: "United Trailers",
  [EligibilityEmployerChoiceId.weAreBlood]: "We Are Blood",
  [EligibilityEmployerChoiceId.wipfli]: "Wipfli",
  [EligibilityEmployerChoiceId.soleraPebtf]: "PEBTF",
  [EligibilityEmployerChoiceId.stateOfGeorgia]: "State of Georgia"
};

export const eligibilityHealthPlanChoiceValues = {
  [EligibilityHealthPlanChoiceId.anthemIndiana]: "Anthem Indiana",
  [EligibilityHealthPlanChoiceId.evernorth]: "Evernorth",
  [EligibilityHealthPlanChoiceId.cignaIfp]: "Cigna IFP",
  [EligibilityHealthPlanChoiceId.solera]: "Solera",
  [EligibilityHealthPlanChoiceId.transcarent]: "Transcarent"
};
